import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { DialogFrameModule } from "src/app/common/components/dialog-frame/dialog-frame.module";
import { MediaPlayerModule } from "src/app/common/components/media-player/media-player.module";
import { WebinarDialogComponent } from "./webinar-dialog.component";

@NgModule({
  declarations: [WebinarDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MediaPlayerModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    DialogFrameModule
  ]
})
export class WebinarDialogModule {}
